import { apiInstance, apiResponse, getLoadingState, ApiError } from '../../Api';
import { ProfessorComMonoEPreModel, ProfessorModel } from './Model';
import { MembroDaBancaModel } from '../Banca';
import { MonografiaModel } from '../Monografia';
import { AlunoModel } from '../Aluno';

export const fetchProfessores = async (): Promise<apiResponse<ProfessorModel[]>> => {
  try {
    const fetchResult = await apiInstance.get<ProfessorModel[]>('/professor');
    return {
      data: fetchResult.data,
      status: getLoadingState(fetchResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: [],
      status: getLoadingState(status)
    };
  }
};

export const fetchProfessoresComPaginacao = async (
  page: number,
  pageSize: number,
  search: string
): Promise<apiResponse<ProfessorModel[]>> => {
  try {
    const response = await apiInstance.get<ProfessorModel[]>(
      'funcionario/professores',
      { params: { page, pageSize, search } }
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<ProfessorModel[]>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<ProfessorModel[]>
  }
}

export const fecthProfessorComSuasMonografiasEPreProjetos = async (
  professorId: number
): Promise<apiResponse<ProfessorComMonoEPreModel | undefined>> => {
  try {
    const response = await apiInstance.get<ProfessorComMonoEPreModel>(
      `funcionario/professores/${professorId}`
    );

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<ProfessorComMonoEPreModel>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
};

export const agendarBanca = async (
  monografiaId: number, membros: ProfessorModel[], suplentes: ProfessorModel[], dia: string, hora: string
): Promise<apiResponse<ApiError[]>> => {
  try {
    const dataHoraAgendamento = new Date (dia + ' ' + hora +':00.000Z');
    const agendamentoResult = await apiInstance.post('professor/agendamento',
      {
        MonografiaId: monografiaId,
        Banca: membros,
        Suplentes: suplentes,
        data: dataHoraAgendamento,
        FrontEndLink: window.location.origin
      });

    return {
      data: [],
      status: getLoadingState(agendamentoResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;

    return {
      data: error.response ? error.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const fetchConvitesPendentes = async (): Promise<apiResponse<MembroDaBancaModel[]>> => {
  try {
    const fetchResult = await apiInstance.get<MembroDaBancaModel[]>('professor/banca/pendentes');
    return {
      data: fetchResult.data,
      status: getLoadingState(fetchResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: [],
      status: getLoadingState(status)
    };
  }
};

export const fetchConvitesAceitos = async (): Promise<apiResponse<MembroDaBancaModel[]>> => {
  try {
    const fetchResult = await apiInstance.get<MembroDaBancaModel[]>('professor/banca/aceitos');
    return {
      data: fetchResult.data,
      status: getLoadingState(fetchResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: [],
      status: getLoadingState(status)
    };
  }
};

export const fetchAlunosAtivos = async (): Promise<apiResponse<AlunoModel[]>> => {
  try {
    const fetchResult = await apiInstance.get<AlunoModel[]>('funcionario/alunos/ativos');
    return {
      data: fetchResult.data,
      status: getLoadingState(fetchResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: [],
      status: getLoadingState(status)
    };
  }
};

export const responderConvite = async (MonografiaId: number, Resposta: boolean, Justificativa: string | undefined):
  Promise<apiResponse<ApiError[]>> => {
  try {
    const result = await apiInstance.post(`professor/banca/${MonografiaId}`,
      {
        Resposta,
        Justificativa,
        FrontEndLink: window.location.origin,
      });

    return {
      data: [],
      status: getLoadingState(result.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;

    return {
      data: error.response ? error.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const recuperarInformacoesConvite = async (MonografiaId: number): Promise<apiResponse<MonografiaModel>> => {
  try {
    const result = await apiInstance.get(`professor/banca/${MonografiaId}`);

    return {
      data: result.data,
      status: getLoadingState(result.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;

    return {
      data: {} as MonografiaModel,
      status: getLoadingState(status)
    };
  }

};

export const editarDataAgendamento = async (monografiaId: number, dia: string, hora: string): Promise<apiResponse<ApiError[]>> => {
  try {
    const dataHoraAgendamento = new Date (dia + ' ' + hora +':00.000Z');

    const agendamentoResult = await apiInstance.post('professor/agendamento/editar',
      {
        MonografiaId: monografiaId,
        Data: dataHoraAgendamento,
        FrontEndLink: window.location.origin
      });

    return {
      data: [],
      status: getLoadingState(agendamentoResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;

    return {
      data: error.response ? error.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const alterarVagasPreProjeto = async (
  professorId: number,
  vagasPreProjeto: number
): Promise<apiResponse<ApiError[]>> => {
  try {
      const fetchResponce = await apiInstance.put(
          `funcionario/professores/${professorId}}`,
          { Id: professorId, VagasPreProjeto: vagasPreProjeto }
      );
      return {
          data: [],
          status: getLoadingState(fetchResponce.status)
      };
  } catch (e) {
      const status = e.response ? e.response.status : 500;

      return {
          data: e.response ? e.response.data : [],
          status: getLoadingState(status)
      };
  }
};

export const ativarDesativarUmProfessor = async (
  professorId: number,
  professorAtivo: boolean
): Promise<apiResponse<ApiError[]>> => {
  try {
      const fetchResponce = await apiInstance.post(
          'funcionario/professores/ativar',
          { professorId, professorAtivo }
      );
      return {
          data: [],
          status: getLoadingState(fetchResponce.status)
      };
  } catch (e) {
      const status = e.response ? e.response.status : 500;

      return {
          data: e.response ? e.response.data : [],
          status: getLoadingState(status)
      };
  }
};

export const ativarDesativarMembroBanca = async (
  professorId: number,
  ativo: boolean
): Promise<apiResponse<ApiError[]>> => {

  try {
      const fetchResponce = await apiInstance.post(
          'funcionario/professores/ativarmembrobanca',
          { professorId, ativo }
      );
      return {
          data: [],
          status: getLoadingState(fetchResponce.status)
      };
  } catch (e) {
      const status = e.response ? e.response.status : 500;

      return {
          data: e.response ? e.response.data : [],
          status: getLoadingState(status)
      };
  }
};

export const inserirMonografia = async (
  alunoId: number,
  professorId: number,
  titulo: string,
): Promise<apiResponse<undefined>> => {
  try {
    const result = await apiInstance.post('funcionario/monografia/monografia', {
      alunoId: alunoId,
      professorId: professorId,
      titulo: titulo,
    });
    return {
      status: getLoadingState(result.status)
    } as apiResponse<undefined>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};
